import i18n from '@/i18n'

export default [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: i18n.t('sign.login')
    }
  }
]